import { render } from "./anc_visits.vue?vue&type=template&id=55fc2e4a&scoped=true"
import script from "./anc_visits.vue?vue&type=script&lang=js"
export * from "./anc_visits.vue?vue&type=script&lang=js"

import "./anc_visits.vue?vue&type=style&index=0&id=55fc2e4a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fc2e4a"]])

export default __exports__